import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, NgFor } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OptionsListStore } from 'src/app/store/options-list-store';
import { OptionsList } from 'src/app/models/optionsList.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { filter, map } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { Question } from 'src/app/models/question.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AnswerOptionItem } from 'src/app/models/answerOptionItem.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-autocomplete-question-display',
    imports: [CommonModule, MatFormFieldModule, MatSelectModule, NgFor, MatInputModule, FormsModule, ReactiveFormsModule, TranslateDirective, TranslatePipe, OverlayModule],
    templateUrl: './autocomplete-question-display.component.html',
    styleUrls: ['./autocomplete-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteQuestionDisplayComponent implements OnInit {
  @Input()
  question?: Question;
  @Input() modularId?: string;
  @Input() modularOrder?: number;
  optionsListDetails?: OptionsList;
  @Input()
  isSub: boolean = false;
  @Input()
  isRequierd?: boolean;
  @Input() viewAnswer = false;

  @ViewChild('trigger') trigger!: ElementRef;
  myAnswer?: Answer;
  answer = new FormControl<AnswerOptionItem | null>(null);
  #answerStore = inject(AnswersStore);
  #questionnaireStore = inject(QuestionnaireStore);
  eventDeleteModularuestionId$ = this.#answerStore.eventDeleteModularuestionId$;
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));
  currentStep$ = this.#questionnaireStore.currentStepIndex$;
  isSelectOpen = false;
  isDisableSignal$ = toSignal(this.isNotUser$);
  readonly positonArea = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }] as ConnectedPosition[];

  ngOnInit(): void {
    this.answer.setValidators(this.question?.requierd ? [Validators.required] : null);
    this.optionsListDetails = this.question?.optionsList;

    this.answer.valueChanges.pipe(filter(x => x != null))
      .subscribe(
        ans => {
          if (!!this.question?.isFilterField) {
            this.#answerStore.updateMainAnswerAndSync(ans!.name);
          }
          // var option = this.optionsListDetails?.answerOptionItem?.filter(op => op.id == ans);
          this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, modularQuestionGuid: this.modularId, modularRowNum: this.modularOrder, optionItemGuid: ans!.guid, isValid: this.answer.valid })
        });

    this.eventDeleteModularuestionId$.pipe(filter(id => id != undefined && id == this.question?.id)).subscribe(
      x => {
        this.getAnswers()
      }
    )
    this.getAnswers();
  }
  getAnswers() {

    this.#answerStore.answers$.pipe(map(arr => arr.find(ans => ans.questionId == this.question?.id && (!this.modularId || (ans.modularQuestionGuid == this.modularId && ans.modularRowNum == this.modularOrder))))).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        var op = this.optionsListDetails?.answerOptionItem?.find(op => op.guid == x.optionItemGuid);
        this.answer.setValue(op ?? null, { emitEvent: false });
      }
    }).unsubscribe();
  }

  updateSelection(op: AnswerOptionItem) {
    this.answer.setValue(op);
    this.isSelectOpen = false;
  }
  openList() {
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 200 > viewportHeight) { // assuming 200px height for the menu
      this.positonArea[0].overlayY = 'center';
    } else {
      if (triggerRect.bottom + 400 > viewportHeight) { // assuming 200px height for the menu
        this.positonArea[0].overlayY = 'bottom';
      } else {

        this.positonArea[0].overlayY = 'top';
      }
    }
    this.isSelectOpen = true;
  }
}
